<template>
  <div class="content">
    <div class="ultraviolet-rays">
      <div class="publish-time" v-if="ultravioletRaysResult.date">
        <div>{{ ultravioletRaysResult.date }}更新</div>
      </div>
      <div class="ultraviolet-rays-wrap">
        <div class="ultraviolet-rays-list" ref="ultravioletRaysList">
          <div :id="chartId"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import echarts from '@/config/echarts/index.js'
import { mapMutations, mapState } from 'vuex'
import { getUltravioletRaysOption, getUltravioletRaysOptionP } from '@/config/echarts/option/ultraviolet-rays'

export default {
  props: ['params', 'forecastType', 'cardEchart', 'ultravioletRaysChartId'],
  data () {
    return {
      charts: '',
      timmer: null,
      chartId: ''
    }
  },
  watch: {
    activeCountyId: {
      handler () {
        setTimeout(() => {
          this.$nextTick(() => {
            this.getUltravioletRaysData()
          })
        }, 100)
      },
      immediate: true
    },
    forecastType () {
      this.resetEchart()
    },
    ultravioletRaysResult: {
      handler () {
        this.$nextTick(() => {
          this.getUltravioletRaysData()
        })
      },
      deep: true
    }

  },
  computed: {
    ...mapState('home', ['objsList', 'activeCountyId', 'ultravioletRaysResult'])
  },
  created () {
    if (!this.ultravioletRaysChartId) {
      this.chartId = 'ultraviolet-rays-chart-c'
    } else {
      this.chartId = this.ultravioletRaysChartId
    }
  },
  methods: {
    initEchart () {
      // 24小时预报温度曲线图
      const idName = this.chartId
      console.log('idName', idName)
      const tempChart = echarts.init(document.getElementById(idName))
      const options = this.getChatOptions()
      tempChart.setOption(options)
      this.charts = tempChart
      this.$nextTick(() => {
        this.charts.resize()
      })
      // 页面缩放
      window.onresize = () => {
        Vue.prototype.$rootFontSize = document.body.clientWidth / 1920 * 16
        document.getElementsByTagName('html')[0].style.fontSize = this.$rootFontSize + 'px'
        this.resetEchart()
      }
      this.$bus.$on('changeCardData', () => {
        this.$nextTick(() => {
          this.charts.resize()
        })
      })
    },
    getChatOptions () {
      return this.chartId === 'ultraviolet-rays-chart-p' ? getUltravioletRaysOptionP() : getUltravioletRaysOption()
    },
    // 获取gif预报
    async getUltravioletRaysData () {
      const ultravioletRaysResult = this.ultravioletRaysResult
      if (!ultravioletRaysResult || !ultravioletRaysResult.times) {
        return
      }
      if (!this.charts) {
        this.initEchart()
      }
      const option1 = this.getChatOptions()
      const times = ultravioletRaysResult.times
      // 过滤出整点数据
      const labels = times.filter(v => v.split(':')[1] === '00')
      let interval = Math.floor(labels.length / 5)
      if (interval <= 0) {
        interval = 1
      } else if (interval === 1) {
        interval = 2
      }
      const tmpSet = new Set()
      const labelSet = Array.from(new Set(Array.from(labels)))
      for (let i = 0; i < labelSet.length; i += interval) {
        tmpSet.add(labelSet[i])
      }
      const tmpLabel = Array.from(tmpSet)
      if (tmpLabel.length > 4) {
        option1.xAxis.axisLabel.customValues = tmpLabel
      }
      option1.xAxis.data = times
      option1.series[0].data = ultravioletRaysResult.uvis
      this.charts.clear()
      this.charts.setOption(option1)
      this.$nextTick(() => {
        this.charts.resize()
      })
    },

    resetEchart () {
      this.$nextTick(() => {
        this.charts && this.charts.resize()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.6vw 1.04vw 0.56vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  width: 100%;
  height: 100%;
  // pointer-events: none;

  .ultraviolet-rays {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0vw;

    .ultraviolet-rays-wrap {
      position: relative;
      // top: -2.04vw;
      width: 100%;
      margin-top: 0.52vw;
      height: calc(100% - 0.52vw);
      overflow: hidden;

      .ultraviolet-rays-list {
        width: 100% !important;
        height: 100%;
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        transition: all 0.3s linear;

        .item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          width: 5.58rem;

          span {
            font-size: 0.75rem;
            color: #FFF;
          }

          .des {
            font-size: 0.88rem;
            color: #FFF;
          }

          img {
            width: 2.25rem;
          }

          .chart {
            height: 90%;
          }

          .wind {
            color: #FFF;
          }
        }

        #ultraviolet-rays-chart,
        #ultraviolet-rays-chart-c,
        #ultraviolet-rays-chart-p {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
        }
      }
    }

    .left-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/左.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      left: 1.2rem;
      cursor: pointer;
    }

    .right-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/右.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      right: 1.2rem;
      cursor: pointer;
    }
  }

  .days-forecast {
    height: 100%;
    // padding: 8% 3% 0 2%;
    box-sizing: border-box;

    .days-forecast-list {
      display: flex;
      justify-content: space-between;
      height: 100%;
      position: relative;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 6.85rem;

        span {
          font-size: 0.75rem;
          color: #FFF;
        }

        font {
          font-size: 0.88rem;
          color: #FFF;
        }

        img {
          width: 2rem;
        }

        .chart {
          height: 50%;
        }
      }

      #high-low-temp-chart {
        position: absolute;
        left: 2.3rem;
        right: 2.3rem;
        top: 52%;
        height: 45%;
      }
    }
  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: .8vw;;
    color: #FFF;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}
</style>
